export const SKILLS = [
  { name: "react", url: "platform/react.png", width: "50", height: "45" },
  { name: "js", url: "platform/js-icon.png", width: "45", height: "45" },
  { name: "ts", url: "platform/ts-icon.png", width: "45", height: "45" },
  { name: "nextjs", url: "platform/nextjs.png", width: "60", height: "38" },
  { name: "redux", url: "platform/redux.png", width: "80", height: "60" },
  {
    name: "firebase",
    url: "platform/firebase-icon.png",
    width: "80",
    height: "30",
  },
  { name: "apollo", url: "platform/apollo.png", width: "60", height: "60" },
  { name: "java", url: "platform/java.png", width: "80", height: "60" },
  {
    name: "springboot",
    url: "platform/springboot.png",
    width: "80",
    height: "45",
  },
  { name: "api", url: "platform/api-icon.png", width: "80", height: "60" },
  {
    name: "microservices",
    url: "platform/microservices-icon.png",
    width: "80",
    height: "60",
  },
  { name: "mysql", url: "platform/mysql-icon.png", width: "80", height: "60" },
  {
    name: "postgres",
    url: "platform/postgres-icon.png",
    width: "60",
    height: "55",
  },
  {
    name: "maria",
    url: "platform/mariadb-icon.png",
    width: "55",
    height: "50",
  },
  { name: "nodejs", url: "platform/nodejs.png", width: "60", height: "40" },
  { name: "docker", url: "platform/docker.png", width: "80", height: "45" },
  { name: "aws", url: "platform/aws.png", width: "45", height: "30" },
  { name: "vercel", url: "platform/vercel.png", width: "65", height: "40" },
];
